import { useMutation } from '@apollo/client';

import { DELETE_VOUCHER } from '../graphql/mutations/deleteVoucherMutation.graphql';
import { VOUCHERS } from '../graphql/query/vouchersQuery.graphql';

export const useDeleteVoucherMutation = (onCompleted: () => void) => {
  const [mutate] = useMutation(DELETE_VOUCHER, { onCompleted });

  const deleteVoucher = (voucherId: string) => {
    mutate({
      variables: {
        voucherId,
      },
      refetchQueries: [VOUCHERS],
    });
  };

  return { deleteVoucher };
};
